import { call, put, takeEvery } from 'redux-saga/effects'
import {
  GET_WORKORDERS,
  ADD_WORKORDER,
  UPDATE_WORKORDER,
  DELETE_WORKORDER,
} from './actionTypes'
import {
  getWorkOrdersSuccess,
  getWorkOrdersFail,
  addWorkOrderSuccess,
  addWorkOrderFail,
  updateWorkOrderSuccess,
  updateWorkOrderFail,
  deleteWorkOrderSuccess,
  deleteWorkOrderFail,
  setWorkOrderFieldErrors,
  getWorkOrders,
} from './actions'
import axiosInstance from 'pages/Utility/axiosInstance'
import toast from 'react-hot-toast'
import Cookies from 'js-cookie'

// API calls
const fetchWorkOrdersApi = (data) => axiosInstance.get('', { params: { sp: 'usp_GetWorkorderReport', workOrderStatus: data?.status || null, scheduledFromDate: data?.startDate || null, scheduledToDate: data?.endDate || null, TeamID: data?.teamId || null, createdBy: data?.userId || null,createdDate:data?.createdAt != 'NaN-NaN-NaN' ? data?.createdAt : null,solutionId: (data?.solutionId && data?.solutionId != "null") ? data?.solutionId: null,sabelUserId: (data?.sebelUserId &&  data?.sebelUserId !=="undefined") ? `${data?.sebelUserId}` : null } })
const addWorkOrderApi = (workorder) => axiosInstance.post('', workorder)
const updateWorkOrderApi = (workorder) => axiosInstance.post('', workorder)
const deleteWorkOrderApi = (id) => axiosInstance.post('', { sp: 'usp_DeleteWorkOrder', workOrderId: id })

// Sagas
function* getWorkOrdersSaga(action) {
  try {
    const { data } = yield call(fetchWorkOrdersApi, action?.payload)
    yield put(getWorkOrdersSuccess(data))
  } catch (error) {
    yield put(getWorkOrdersFail(error.response?.data || error.message))
  }
}

function* addWorkOrderSaga(action) {
  try {
    const { data } = yield call(addWorkOrderApi, action.payload?.workorder)
    yield put(addWorkOrderSuccess(data))
    const id = JSON.parse(Cookies.get('authUser'))?.userId
    action.payload?.navigate(`/workOrderDetails/${data?.Data?.[0]?.workOrderId}`)
    toast.success('Work order added successfully!')
    yield put(getWorkOrders(id))
  } catch (error) {
    if (error.response?.status === 400 && error.response?.data?.fieldErrors) {
      yield put(setWorkOrderFieldErrors(error.response.data.fieldErrors))
    } else {
      yield put(addWorkOrderFail(error.response?.data || error.message))
    }
  }
}

function* updateWorkOrderSaga(action) {
  try {
    const { data } = yield call(updateWorkOrderApi, action.payload)
    yield put(updateWorkOrderSuccess(data))
    const id = JSON.parse(Cookies.get('authUser'))?.userId
    toast.success('Work order updated successfully!')
    yield put(getWorkOrders(id))
  } catch (error) {
    if (error.response?.status === 400 && error.response?.data?.fieldErrors) {
      yield put(setWorkOrderFieldErrors(error.response.data.fieldErrors))
    } else {
      yield put(updateWorkOrderFail(error.response?.data || error.message))
    }
  }
}

function* deleteWorkOrderSaga(action) {
  try {
    yield call(deleteWorkOrderApi, action.payload)
    yield put(deleteWorkOrderSuccess(action.payload))
    const id = JSON.parse(Cookies.get('authUser'))?.userId
    toast.success('Work order deleted successfully!')
    yield put(getWorkOrders(id))
  } catch (error) {
    yield put(deleteWorkOrderFail(error.response?.data || error.message))
  }
}

// Watcher saga
function* workOrderSaga() {
  yield takeEvery(GET_WORKORDERS, getWorkOrdersSaga)
  yield takeEvery(ADD_WORKORDER, addWorkOrderSaga)
  yield takeEvery(UPDATE_WORKORDER, updateWorkOrderSaga)
  yield takeEvery(DELETE_WORKORDER, deleteWorkOrderSaga)
}

export default workOrderSaga
